import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

promotionCodeFormStyles.applyPromotionGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start !important;
        margin-top: 22px !important;
    `,
};
